import { forwardRef, ForwardRefRenderFunction } from 'react'
import { Checkbox as MUICheckbox, CheckboxProps as MuiProps } from '@mui/material'
import { FormControlLabelStyled } from './styles'
import { ReactComponent as IconDefault } from './svg/Default.svg'
import { ReactComponent as IconChecked } from './svg/Checked.svg'
import { ReactComponent as IconIndeterminate } from './svg/Multiple.svg'
import { ReactComponent as IconDefaultSmall } from './svg/DefaultSmall.svg'
import { ReactComponent as IconCheckedSmall } from './svg/CheckedSmall.svg'
import { ReactComponent as IconIndeterminateSmall } from './svg/IndeterminateSmall.svg'

export interface CheckboxProps {
  label?: React.ReactNode
  indeterminate?: boolean
  checked?: boolean
  onChange?: MuiProps['onChange']
  id?: string
  disabled?: boolean
  size?: 'default' | 'small'
  bold?: boolean
}

const CheckboxComponent: ForwardRefRenderFunction<HTMLInputElement, CheckboxProps> = (
  {
    checked,
    indeterminate,
    onChange,
    label = '',
    id,
    disabled = false,
    size = 'default',
    bold = false
  },
  ref
) => {
  const sizeIcons = {
    default: {
      default: <IconDefault />,
      checked: <IconChecked data-testid="checked-icon-checkbox" />,
      indeterminate: <IconIndeterminate />
    },
    small: {
      default: <IconDefaultSmall />,
      checked: <IconCheckedSmall data-testid="checked-icon-checkbox" />,
      indeterminate: <IconIndeterminateSmall />
    }
  }

  return (
    <FormControlLabelStyled
      label={label}
      disabled={disabled}
      size={size}
      bold={bold}
      control={
        <MUICheckbox
          data-testid="checkbox"
          id={id}
          inputRef={ref}
          checked={checked}
          indeterminate={indeterminate}
          onChange={onChange}
          sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
          icon={sizeIcons[size].default}
          checkedIcon={sizeIcons[size].checked}
          indeterminateIcon={sizeIcons[size].indeterminate}
        />
      }
    />
  )
}

export const Checkbox = forwardRef(CheckboxComponent)
